import React from 'react';
import { INDICATION_TYPES, STATIC_INDICATION_TYPES } from 'modules/taboola-common-frontend-modules/Indications';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { FILTER_TYPE } from '../../../modules/campaigns-reports/config/filters/filterType';

export const AVAILABLE_MSV2_CREATIVE_REPORT_FILTERS_START_DATE = '2022-11-01';
export const UNAVAILABLE_MSV2_CREATIVE_REPORT_FILTERS = [
    FILTER_TYPE.OS_FAMILY,
    FILTER_TYPE.BROWSER,
    FILTER_TYPE.OS_VERSION,
];

export const reportFiltersDataUnavailableIndication = {
    staticIndicationType: STATIC_INDICATION_TYPES.PARTIAL_REPORT_DATA,
    type: INDICATION_TYPES.WARNING,
    iconTypeOverride: INDICATION_TYPES.WARNING,
    highlight: (
        <FormattedMessage
            id="app.campaign.indication.reportFiltersUnavailableWarning.highlight"
            defaultMessage="Filters are unavailable for this date range"
        />
    ),
    message: (
        <FormattedMessage
            id="app.campaign.indication.reportFiltersUnavailableWarning.revised.message"
            defaultMessage="- Please choose a date range that is less than 2 years or remove the filters"
        />
    ),
};
